'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeviceProvider = function (_Component) {
  _inherits(DeviceProvider, _Component);

  _createClass(DeviceProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        device: this.device
      };
    }
  }]);

  function DeviceProvider(props, context) {
    _classCallCheck(this, DeviceProvider);

    var _this = _possibleConstructorReturn(this, (DeviceProvider.__proto__ || Object.getPrototypeOf(DeviceProvider)).call(this, props, context));

    _this.device = props.device;
    return _this;
  }

  _createClass(DeviceProvider, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react.Children.only(children);
    }
  }]);

  return DeviceProvider;
}(_react.Component);

exports.default = DeviceProvider;


DeviceProvider.propTypes = {
  children: _react.PropTypes.element.isRequired,
  device: _react.PropTypes.string.isRequired
};

DeviceProvider.childContextTypes = {
  device: _react.PropTypes.string
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DeviceProvider.js
 ** module id = 798
 ** module chunks = 0
 **/